export const figLogoUrl = './assets/images/fig-logo.svg';